import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@mui/material";
import { get } from "lodash";
import BSInput from "../../../common/js/components/BSInput";
import BSSelect from "../../../common/js/components/BSSelect";
import utils from "../utils/index";
import "./Invoice.css";
import InvoiceMonth from "./InvoiceMonth";

const InvoicePeriod = (props) => {
    const { disableInputs, errors, handlePeriodChange, period } = props;
    const hasEscalationErrors = errors.escalationRate || errors.escalationRateType;
    return (
        <Accordion className="withTable">
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <div className="panelMegaLink">
                    <div className="invoiceHeaderText">
                        <div className="invoiceSubHeaderText">
                            <div>
                                <span className="tableTitleMonth">{period.periodId}</span>
                            </div>
                            <div>
                                <div className="invoiceSubHeaderText">
                                    <div className="tableTitleDate">
                                        {period.startDate} - {period.endDate}{" "}
                                        {period.preTermPeriod === true || period.postTermPeriod === true
                                            ? "(Outside Term)"
                                            : ""}
                                    </div>
                                </div>
                                <div>
                                    <span className="tableTitleDetails">
                                        {period.summary.totalMonths} month(s) / {period.summary.freeMonths} month(s)
                                        free / {period.summary.discountedMonths} month(s) discounted
                                    </span>
                                </div>
                            </div>
                        </div>
                        {period.periodId !== "S" && period.periodId !== "1" && period.periodId !== "E" && (
                            <div
                                style={{
                                    display: "flex",
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    maxHeight: "55px",
                                }}
                            >
                                <div
                                    className="tableTitleDetails"
                                    style={{
                                        paddingBottom: hasEscalationErrors ? "0px" : "10px",
                                        paddingRight: "10px",
                                        fontSize: "13px",
                                        alignSelf: "center",
                                    }}
                                >
                                    Escalation Rate
                                </div>
                                <BSInput
                                    id="escalationRate"
                                    onClick={(event) => event.stopPropagation()}
                                    value={get(period, "escalationRate", null)}
                                    error={errors.escalationRate}
                                    onChange={(e) => {
                                        handlePeriodChange(period.periodNumber, e.target.id, e.target.value);
                                    }}
                                    placeholder="Enter escalation rate"
                                    disabled={disableInputs === true}
                                    extraFormControlStyles={{
                                        margin: "0px",
                                        minWidth: "80px",
                                        maxWidth: "80px",
                                        paddingTop: "4px",
                                    }}
                                    extraInputStyles={{ marginTop: hasEscalationErrors ? "15px" : 0 }}
                                />
                                <div>
                                    <BSSelect
                                        id="escalationRateType"
                                        combinedField="combinedFieldShiftLeft"
                                        error={errors.escalationRateType}
                                        value={get(period, "escalationRateType", null)}
                                        onChange={(e) => {
                                            handlePeriodChange(period.periodNumber, e.target.id, e.target.value);
                                        }}
                                        disabled={disableInputs === true}
                                        onClick={(event) => event.stopPropagation()}
                                        options={[
                                            {
                                                value: "%",
                                                label: "%",
                                            },
                                            {
                                                value: "$",
                                                label: "$",
                                            },
                                        ]}
                                        extraInputStyles={{
                                            marginTop: hasEscalationErrors ? "-3px" : "-18px",
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                        <div>
                            <span className="tableTitleValue">
                                {utils.operations.toDollarAmount(period.summary.totalAmount)}
                            </span>
                        </div>
                    </div>
                </div>
            </AccordionSummary>
            <AccordionDetails className="withTable">
                <Divider />
                <Table padding="none">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center"></TableCell>
                            <TableCell align="center">Month Range</TableCell>
                            <TableCell align="center">Free Rent</TableCell>
                            <TableCell align="center" numeric>
                                Discount %
                            </TableCell>
                            <TableCell align="center" numeric style={{ minWidth: "5em" }}>
                                Rate
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Object.keys(period["months"]).map((month, i) => (
                            <InvoiceMonth
                                {...props}
                                monthDetail={period["months"][month]}
                                periodNumber={period.periodNumber}
                                disableInputs={disableInputs || period.preTermPeriod || period.postTermPeriod}
                            />
                        ))}
                    </TableBody>
                </Table>
            </AccordionDetails>
        </Accordion>
    );
};

export default InvoicePeriod;
